<div *ngIf="showAction()" class="d-flex align-items-center position-absolute top-0 end-0 m-9 mt-6">
  <a
    href="#"
    class="btn btn-outline btn-outline-primary ps-7 mb-2"
    data-kt-menu-trigger="click"
    data-kt-menu-attach="parent"
    data-kt-menu-placement="bottom-end"
    >Action
    <span class="svg-icon svg-icon-2 me-0">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
          fill="currentColor"
        />
      </svg>
    </span>
  </a>

  <div
    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-300px py-4 fs-6"
    data-kt-menu="true"
  >
    <div class="menu-item px-3">
      <a
        class="menu-link"
        (click)="onClickResetPassword()"
        *ngIf="tab === DistributorStatusEnumTabString.ACTIVE && privilegeResetPassword.value"
      >
        <span
          [inlineSVG]="STRING_CONSTANTS.ICON.IC_RESET_PASSWORD"
          class="svg-icon svg-icon-2 me-3"
        ></span>
        <span>Reset Password</span>
      </a>
      <a
        class="menu-link"
        *ngIf="tab === DistributorStatusEnumTabString.REGISTERED && privilegePrintKUL.value"
        (click)="onPrint()"
      >
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PRINT" class="svg-icon svg-icon-2 me-3"></span>
        <span>Print KUL & Pakta Integritasi</span>
      </a>
      <a
        class="menu-link"
        (click)="onClickNonActiveCustomer()"
        *ngIf="tab === DistributorStatusEnumTabString.ACTIVE && privilegeNonActive.value"
      >
        <span
          class="svg-icon svg-icon-24 me-4"
          inlineSVG="{{ STRING_CONSTANTS.ICON.IC_REMOVE_USER }}"
        ></span>
        Nonaktifkan Distributor
      </a>
    </div>
  </div>
</div>

<mat-tab-group
  (selectedIndexChange)="handleTabChange($event)"
  [(selectedIndex)]="tabIndex"
  animationDuration="0ms"
  class="line mt-8"
  mat-stretch-tabs="false"
>
  <ng-container *ngFor="let tab of tabList; index as i">
    <mat-tab
      *ngIf="tab['privilege']"
      [label]="utilities.mapKeyToString(TabListLabelDetailDistributor, tab['labelKey'])"
    >
      <ng-container *ngIf="i === tabIndex && tab.component">
        <ng-container *ngComponentOutlet="tab.component"></ng-container>
      </ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>

<app-modal
  #modalResetPassword
  [callbackSubmit]="onOkeResetPassword"
  [modalConfig]="modalConfigResetPassword"
>
  <div class="text-center">
    Password dari distributor {{ dataResetPassword.value?.name }} akan direset. Apakah anda yakin?
  </div>
</app-modal>
<!--modal reset password-->
<app-modal
  #modalSuccessResetPassword
  [callbackCancel]="onClickDetailPopup"
  [callbackSubmit]="onSuccessResetPassword"
  [modalConfig]="modalSuccessResetPasswordConfig"
>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <span [inlineSVG]="STRING_CONSTANTS.ICON.SUCCESS_ALERT" class="mb-6"></span>
    <ng-container *ngIf="newPasswordResult | async as res">
      <div class="text-center">
        Password berhasil direset. Password dari distributor {{ res.distributor_name }} ({{
          res.email
        }}):
      </div>
      <div class="group_user_password">
        <div class="mt-5 d-flex w-100 justify-content-center on_copy_password align-items-center">
          <strong class="text-center">{{ res.password }}</strong>
          <div class="d-flex" ngbPopover="Password berhasil di copy" placement="top">
            <span
              (click)="utilities.copyToClipboard(res.password)"
              [inlineSVG]="STRING_CONSTANTS.ICON.IC_COPY"
              class="cursor-pointer"
            ></span>
          </div>
        </div>
        <div class="text-center mt-4">
          Regional Head : {{ res.regional_head_name }} ({{ res.phone_number_regional_head }}
          )
        </div>
      </div>
    </ng-container>
  </div>
  <div class="mt-4 p-3 d-flex align-items-center rounded justify-content-between bg-gray-100">
    <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_INFO"></span>
    <div class="fs-8">Pastikan password berhasil dicopy sebelum menutup pop up.</div>
  </div>
</app-modal>

<app-modal-non-active-customer
  #modalNonActiveCustomer
  [customerType]="'distributor'"
></app-modal-non-active-customer>
